export const THUMBNAIL_WIDTH = 920;
export const THUMBNAIL_HEIGHT = 720;
